import React from 'react';
import { Header } from 'mini-header';

const styles = require('./MailReadingPaneHeader.scss');
const classNames = require('classnames/bind').bind(styles);

export const MailReadingPaneHeaderPlaceholder: React.FC<{}> = props => (
    <Header showBorder headerStyles={classNames(styles.mailReadingPaneHeader)} />
);
